// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperSelector-cls1_ok3","cls2":"PaperSelector-cls2_6FR PaperSelector-cls1_ok3"};